import React from "react";
import NewsApiComponent from "../../../airports/p11v5-nsru-backend/web-services/NewsApiComponent";
import NewsDisplay1 from "t4/components/parts/news/NewsDisplay1";
import NewsPage from "project-components/pages/NewsPage";
import NewsCategoryApiComponent from "airports/p11v5-nsru-backend/web-services/NewsCategoryApiComponent";
import BlogCard1 from "components/cards/BlogCard1";
import News from "../../../airports/p11v5-nsru-api/News";

class NewsViewGen4 extends React.Component
{
    constructor(props) {
        super(props)
        this.newsId = props.match.params.newsId
        this.state = {
            id: "",
            cover: "",
            title: "Defrault NewsView title",
            detail: "Default NewsView detail",
            newsCategoryName: "Unclassified"
        }
    }

    async readData()
    {
        const newsApi = new NewsApiComponent()
        const NewsCategoryApi = new NewsCategoryApiComponent()
        const NewsApi = new News();

        try {
            var res = await NewsApi.readGen4(this.newsId);
            const coverLink = process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + res.cover.replaceAll('\\', '/')
            this.setState({
                id: res.id,
                cover: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + res.cover.replaceAll('\\', '/'),
                title: res.title,
                detail: res.detail
            })
            NewsCategoryApi.show(res.news_category_id, resNewsCat => {
                this.setState({
                    newsCategoryName: resNewsCat.name
                })
            })
        } catch(e) {
            console.error(e.message)
        }
    }

    componentDidMount()
    {
        this.readData();
    }

    render() {
        return (
            <>
                <NewsPage
                    title={this.state.newsCategoryName ?? "ข่าวประชาสัมพันธ์"}
                    subtitle={this.state.title}
                    leftSide={
                        <>
                            <NewsDisplay1 key={this.newsId} id={this.newsId} isGen4={1} />
                        </>
                    }
                    rightSide={
                        <>
                            {/* <BlogCard1 /> */}
                        </>
                    }
                />
            </>
        );
    }
}

export default NewsViewGen4;
